import script from "./DeleteProductConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteProductConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./DeleteProductConfirmDialog.vue?vue&type=style&index=0&id=47e10cbc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e10cbc"]])

export default __exports__